import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  Button,
} from "@mui/material";

const NewModuleDialog = ({
  open,
  newModuleName,
  newModuleParent,          // <-- NEW
  newModuleBackend,
  newModuleFrontend,
  newModuleError,
  newModuleLoading,
  onClose,
  onChangeModuleName,
  onChangeParentModule,     // <-- NEW
  onToggleBackend,
  onToggleFrontend,
  onCreateModule,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Create new module</DialogTitle>
      <DialogContent dividers>
        <TextField
          autoFocus
          margin="dense"
          label="Module name"
          fullWidth
          value={newModuleName}
          onChange={(e) => onChangeModuleName(e.target.value)}
          helperText="Lowercase, letters/digits/_/-"
        />

        {/* NEW: Parent module (optional) */}
        <TextField
          margin="dense"
          label="Parent module (optional)"
          fullWidth
          value={newModuleParent || ""}
          onChange={(e) => onChangeParentModule(e.target.value)}
          helperText="e.g. devtools (creates devtools/<module>)"
        />

        <Box sx={{ mt: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={newModuleBackend}
                onChange={(e) => onToggleBackend(e.target.checked)}
              />
            }
            label="Create backend module"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={newModuleFrontend}
                onChange={(e) => onToggleFrontend(e.target.checked)}
              />
            }
            label="Create frontend module"
          />
        </Box>

        {newModuleError && (
          <Typography
            variant="caption"
            color="error"
            sx={{ display: "block", mt: 1 }}
          >
            {newModuleError}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={newModuleLoading}>
          Cancel
        </Button>
        <Button
          onClick={onCreateModule}
          variant="contained"
          disabled={newModuleLoading}
        >
          {newModuleLoading ? "Creating..." : "Create module"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewModuleDialog;